<main class="runtime-status view" aria-labelledby="runtime-status-title">
  <section class="readonly-banner" role="status" data-testid="readonly-banner">
    <mat-icon aria-hidden="true">lock</mat-icon>
    <div>
      <strong>Read-only staging</strong>
      <p>Customer data, mutations, workflows, and outbound provider access are unavailable.</p>
    </div>
  </section>

  <mat-card class="cardPlain">
    <div class="custom-card-header">
      <div class="section-header">
        <div class="runtime-status__breadcrumb">Shine Enrich / Runtime status</div>
        <h1 id="runtime-status-title" class="m-0 f-w-500">Shared production runtime evidence</h1>
        <p class="m-0 help-text">
          Authenticated, non-customer evidence from the backend-enforced staging boundary.
        </p>
      </div>
    </div>

    <mat-card-content>
      @if (isLoading) {
        <div class="runtime-status__loading" data-testid="runtime-status-loading">
          <mat-spinner diameter="36"></mat-spinner>
          <p>Loading runtime evidence…</p>
        </div>
      } @else if (isUnavailable) {
        <section class="runtime-status__unavailable" role="alert" data-testid="runtime-status-unavailable">
          <mat-icon aria-hidden="true">warning</mat-icon>
          <div>
            <h2>Runtime evidence unavailable</h2>
            <p>
              This page remains read-only and grants no authority. Confirm the authenticated backend response before
              relying on staging readiness.
            </p>
          </div>
        </section>
      } @else if (runtime) {
        <div class="runtime-status__grid">
          <section class="status-panel" data-testid="runtime-mode">
            <span class="status-panel__label">Enforced mode</span>
            <strong>Shared production · read-only</strong>
            <span class="status-badge status-badge--locked">Locked</span>
          </section>
          <section class="status-panel" data-testid="runtime-readiness">
            <span class="status-panel__label">Readiness</span>
            <strong>{{ readinessLabel(runtime.readiness) }}</strong>
            <span class="status-badge status-badge--{{ runtime.readiness }}">{{ runtime.readiness }}</span>
          </section>
        </div>

        <section class="evidence-panel" aria-labelledby="runtime-evidence-title">
          <div class="evidence-panel__header">
            <div>
              <h2 id="runtime-evidence-title">Immutable deployment evidence</h2>
              <p>Identifiers only; no tenant, CRM, provider, or customer values are requested.</p>
            </div>
          </div>
          <dl class="evidence-list">
            <div>
              <dt>Source commit</dt>
              <dd data-testid="runtime-source-sha">{{ runtime.sourceSha }}</dd>
            </div>
            <div>
              <dt>Container image</dt>
              <dd data-testid="runtime-image-digest">{{ runtime.imageDigest }}</dd>
            </div>
            <div>
              <dt>Read-only contract</dt>
              <dd data-testid="runtime-contract-digest">{{ runtime.contractDigest }}</dd>
            </div>
          </dl>
        </section>

        <section class="boundary-panel" aria-labelledby="runtime-boundary-title">
          <div class="boundary-panel__header">
            <div>
              <h2 id="runtime-boundary-title">Effective boundary</h2>
              <p>The backend remains authoritative if this page is stale or modified.</p>
            </div>
            <span class="status-badge status-badge--ready">Metadata only</span>
          </div>
          <div class="boundary-grid">
            <article>
              <mat-icon aria-hidden="true">block</mat-icon>
              <div>
                <strong>All mutation surfaces denied</strong>
                <p>Routes, schedulers, workers, webhooks, HubSpot, providers, queries, item reads, and writes.</p>
              </div>
            </article>
            <article>
              <mat-icon aria-hidden="true">verified_user</mat-icon>
              <div>
                <strong>One bounded check allowed</strong>
                <p>Database metadata plus the fixed eleven-container metadata contract.</p>
              </div>
            </article>
          </div>
        </section>
      }
    </mat-card-content>
  </mat-card>
</main>
